import { connect, useDispatch } from "react-redux";
import { IFacultyDailyReports } from "../../../../../models/faculty/facultyReports";
import { useEffect } from "react";
import { pageBlockId } from "../../../../../constants/pageBlocks";
import { setReportsDaily } from "../../../../../store/slices/master/reportSlice";
import { baseURL } from "../../../../../constants/commonConstants";
import { getReports } from "../../../../../action/masters/reportActionCreator";
import { ReportFrequency } from "../../../../../models/dashboard/adminDashboard";

const AllDailyFacultyReports = (props: IFacultyDailyReports) => {
  const { getDailyReports, dailyReports } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    getDailyReports(
      pageBlockId.facultyReports,
      undefined,
      ReportFrequency.Daily
    );
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setReportsDaily([]));
    };
  }, []);

  return (
    <div className="widgets">
      <div className="title">
        <h2>All Daily Reports</h2>
      </div>
      <div className="card-wrap">
        <div className="row">
          {dailyReports?.map((report) => (
            <div className="report-all-card col-lg-12 mb-2" key={report.id}>
              <div className="card">
                <div className="img">
                  <img src={baseURL + report.icon} alt="" />
                </div>
                <div className="desc">
                  <h2 className="mb-2">{report.name}</h2>
                  <p>{report.description}</p>
                  <a href={report.url} target="_blank" className="mt-3 btn-arrow btn-block-arrow">
                    <img src="/assets/images/icon/arrow-right.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  getDailyReports: (
    pageBlockId: number,
    noOfItems: undefined,
    ReportFrequency: number
  ) => getReports(undefined, pageBlockId, undefined, ReportFrequency),
};

function mapStateToProps(state: any) {
  return {
    dailyReports: state.report.dailyreports,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllDailyFacultyReports);
